/** Rotulos de tela do tipo de servico (espelham TIPOS_SERVICO do contrato). */
export const ROTULO_TIPO = {
  consulta: 'Consulta',
  retorno: 'Retorno',
  exame: 'Exame',
  procedimento: 'Procedimento',
  cirurgia: 'Cirurgia',
  bariatrica: 'Consulta bariátrica'
};

export const ROTULO_PAGAMENTO = { particular: 'Particular', convenio: 'Convênio' };
